import { Routes } from '@angular/router';
import { ROUTES as aifsRoutes } from '@sia/aifs';
import { ROUTES as authRoutes } from '@sia/auth';
import { Job3ShellComponent } from './shell/shell.component';

export const ROUTES: Routes = [
  ...authRoutes,
  {
    path: 'shell',
    component: Job3ShellComponent,
    children: [
      {
        outlet: 'base',
        path: 'core',
        children: aifsRoutes,
      },
    ],
  },
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: '#', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: '**', redirectTo: 'auth/login' },
];
